import { createApiClient } from './client';
import { sessionStore } from '../auth/session-store';
import { refreshSession } from './refresh';
import { setLastCorrelationId } from '../observability/correlation';

let refreshInFlight: Promise<boolean> | null = null;

async function refreshAccessToken(): Promise<boolean> {
  if (!refreshInFlight) {
    refreshInFlight = refreshSession()
      .then((refreshed) => {
        if (refreshed.kind === 'unavailable') {
          throw new Error('refresh service unavailable');
        }
        return refreshed.kind === 'authenticated' && sessionStore.signIn(refreshed.token, refreshed.session);
      })
      .finally(() => {
        refreshInFlight = null;
      });
  }
  return refreshInFlight;
}

sessionStore.setAccessTokenRefresher(refreshAccessToken);

/**
 * Application-wide API client. Single origin: the panel and the API share the
 * CloudFront distribution (dev proxy locally), so the base URL is the page origin.
 */
export const api = createApiClient({
  // Guarded for non-DOM contexts (workers/tooling) that may import this module.
  baseUrl: typeof window === 'undefined' ? 'http://localhost' : window.location.origin,
  getToken: () => sessionStore.getToken(),
  refresh: refreshAccessToken,
  onUnauthorized: () => sessionStore.expire('expired'),
  onForbiddenMutation: () => sessionStore.expire('permission'),
  onCorrelationId: setLastCorrelationId,
});
